import { render, staticRenderFns } from "./RequestAppointment.vue?vue&type=template&id=35652a0c&scoped=true&"
import script from "./RequestAppointment.vue?vue&type=script&lang=ts&"
export * from "./RequestAppointment.vue?vue&type=script&lang=ts&"
import style0 from "./RequestAppointment.vue?vue&type=style&index=0&id=35652a0c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35652a0c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardActions,VCardText,VSpacer})
